import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { SetStateType } from '../../model/types';

type GSocialStatus = 'active' | 'inactive';

const GSocialStatusContext = createContext<GSocialStatus>('inactive');
const GSocialStatusDispatchContext = createContext<SetStateType<GSocialStatus>>(null);

const useGSocialStatus = () => useContext(GSocialStatusContext);
const useGSocialStatusDispatch = () => useContext(GSocialStatusDispatchContext);

export default function GSocialStatusProvider({ children }: PropsWithChildren) {
    const [gSocialStatus, setGSocialStatus] = useState<GSocialStatus>('inactive');

    return (
        <GSocialStatusDispatchContext.Provider value={setGSocialStatus}>
            <GSocialStatusContext.Provider value={gSocialStatus}>{children}</GSocialStatusContext.Provider>
        </GSocialStatusDispatchContext.Provider>
    );
}

export { useGSocialStatus, useGSocialStatusDispatch, type GSocialStatus };
